import { useAppSelector } from '../useAppSelector';
import * as parentOrganizationSlice from '../../data/parent-organizations.slice';

export const useClientParentOrganization = (
  parengOrgBC: string | undefined,
): string => {
  const parentOrgs = useAppSelector(
    parentOrganizationSlice.selectParentOrganizations,
  );
  const parentOrg = parentOrgs.find(
    (p) => p.parentOrganizationBC === parengOrgBC,
  );
  return parentOrg ? parentOrg.parentOrganizationName : '';
};
